// Elements to Interact
let logo = document.getElementById('top');
let hamburger = document.getElementById('hamburger');

let navMain = document.getElementById('main-nav');
let navBox = navMain.querySelector('.menu');
let navSubBoxes = navBox.querySelectorAll('.menu-sub');
let navItems = navBox.querySelectorAll('.menu-item');

// Logo Focus close Menu
logo.addEventListener('focus', () => navItems.forEach(navItem => navItem.classList.remove('open')), false);

// Hamburger Interaction
hamburger.addEventListener('click', () => {
  if (hamburger.classList.contains('active')) {
    closeMenu();
  } else {
    openMenu();
  }
}, false);

window.addEventListener('keyup', function (e) {
  if (e.key === "Escape" && hamburger.classList.contains('active')) { //escape
    closeMenu()
  }
});

window.addEventListener('resize', function () {
  const width = window.innerWidth;
  if (hamburger.classList.contains('active') && width > '720') {
    closeMenu()
  }
})

function closeMenu() {
  hamburger.parentElement.classList.remove('menuOpen');
  hamburger.classList.remove('active');
  document.querySelector('body').classList.remove('disabled');
}

function openMenu() {
  hamburger.parentElement.classList.add('menuOpen');
  hamburger.classList.add('active');
  document.querySelector('body').classList.add('disabled');
}

// Main Menu Event Listener
navItems.forEach(navItem => {

  // Check if the position of the element its close to Right
  let navItemPos = navItem.offsetLeft + navItem.clientWidth;
  let navBoxSize = navBox.clientWidth - '200';

  if (navItemPos > navBoxSize) navItem.classList.add('right');

  // On Mouse Enter Main Element
  navItem.addEventListener('mouseenter', () => {
    // console.log('wow')
    navItems.forEach(navItem => navItem.classList.remove('open'));
    navItem.classList.add('open');
  }, false);

  // On click Main Element
  navItem.addEventListener('click', () => {
    navItems.forEach(navItem => navItem.classList.remove('open'));
    navItem.classList.add('open');
  }, false);

  // On Focus Menu links
  let navItemLinks = navItem.querySelectorAll('a');
  navItemLinks.forEach(navItemLink => {
    navItemLink.addEventListener('focus', () => {
      navItems.forEach(navItem => navItem.classList.remove('open'));
      navItem.classList.add('open');
    }, false);
  });

});

// Close Menu on Mouse Leave
navBox.addEventListener('mouseleave', () => navItems.forEach(navItem => navItem.classList.remove('open'), false), false);
